import './styles.scss';
import Card from '../../../../common/card';
import OnboardingDialog from '../../../../common/onboarding-dialog';
import { ReactComponent as UserIcon } from '../../../../../assets/icons/user-circle.svg';
import { Button, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import l from '../../../../../lang';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../../../config/routes';
import { useSplitPayments } from '../../../../../store/split-payments';
import { SplitUserType } from '../../../../../store/split-payments/interfaces';

const UserType = () => {
  const [selectedType, setSelectedType] = useState<SplitUserType>(SplitUserType.SELLER);
  const history = useHistory();
  const { step, selectUserType } = useSplitPayments();
  const isTabletMobile = useMediaQuery('(max-width:768px)');

  useEffect(() => {
    if (step !== 1) {
      history.push(Routes.SPLIT_PAYMENTS);
    }
  }, [step]);

  const handleNext = () => {
    selectUserType(selectedType);
    history.push(Routes.SPLIT_PAYMENTS_STEP_INFORMATION);
  };

  return (
    <OnboardingDialog
      dividers={false}
      unpaddingContent
      unpaddingFooter
      fullScreenMobile
      type="md"
      bgColor="#F9FAFB"
      title={`${l('split_payments.title')} - ${l('split_payments.creation.invite')}`}
      body={
        <>
          <div className="split-payments__user-type__container">
            <div style={{ gridColumn: '2 / 3' }}>
              <Card>
                <div>
                  <h2>{l('split_payments.creation.start_collab')}</h2>
                  <p>{l('split_payments.creation.allow_collab')}</p>
                  <p>
                    {l('split_payments.creation.learn_more')}{' '}
                    <a href={l('split_payments.creation.learn_more.href')} target="_blank">
                      {l('split_payments.creation.learn_more.link')}
                    </a>
                  </p>
                  <div className="transaction_detail__title_section">
                    <UserIcon className="transaction_detail__title_section__icon" />
                    {l('split_payments.creation.user_type')}
                  </div>
                  <div className="split-payments__user-type">
                    <div>
                      <div>
                        <Button
                          className="split-payments__user-type__button"
                          variant={selectedType === SplitUserType.SELLER ? 'contained' : 'outlined'}
                          onClick={() => setSelectedType(SplitUserType.SELLER)}
                        >
                          {l('split_payments.creation.user_type.seller')}
                        </Button>
                        {!isTabletMobile && <p>{l('split_payments.creation.user_type.seller.desc')}</p>}
                      </div>
                    </div>
                    <div>
                      <div>
                        <Button
                          className="split-payments__user-type__button"
                          variant={selectedType === SplitUserType.COLLABORATOR ? 'contained' : 'outlined'}
                          onClick={() => setSelectedType(SplitUserType.COLLABORATOR)}
                        >
                          {l('split_payments.creation.user_type.collaborator')}
                        </Button>
                        {!isTabletMobile && <p>{l('split_payments.creation.user_type.collaborator.desc')}</p>}
                      </div>
                    </div>
                  </div>

                  <div>
                    {isTabletMobile && selectedType === SplitUserType.COLLABORATOR && (
                      <p>{l('split_payments.creation.user_type.collaborator.desc')}</p>
                    )}
                    {isTabletMobile && selectedType === SplitUserType.SELLER && (
                      <p>{l('split_payments.creation.user_type.seller.desc')}</p>
                    )}
                  </div>

                  <div className="split-payments__user-type__buttons">
                    <Button
                      variant="contained"
                      size="large"
                      onClick={() => history.push(Routes.SPLIT_PAYMENTS)}
                      sx={{ backgroundColor: '#E8E8E8', color: 'black', ':hover': { backgroundColor: '#D0D0D0' } }}
                    >
                      {l('common.cancel')}
                    </Button>
                    <Button variant="contained" size="large" onClick={handleNext}>
                      {l('common.next')}
                    </Button>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </>
      }
      menuItems={[
        { title: l('split_payments.creation.menu.introduction'), completed: true, selected: false },
        {
          title: l('split_payments.creation.user_type'),
          subItems: [
            {
              title: l('split_payments.creation.menu.seller_collab'),
              completed: false,
              selected: true,
            },
          ],
        },
        {
          title: l('split_payments.creation.menu.collaboration_info'),
          subItems: [
            {
              title: l('split_payments.creation.menu.collaboration_info'),
              completed: false,
              selected: false,
            },
          ],
        },
        {
          title: l('split_payments.creation.menu.terms_and_conditions'),
          subItems: [
            {
              title: l('split_payments.creation.menu.terms_and_conditions_approve'),
              completed: false,
              selected: false,
            },
            {
              title: l('split_payments.creation.menu.agreement'),
              completed: false,
              selected: false,
            },
          ],
        },
      ]}
    />
  );
};

export default UserType;
